import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    setCurrentPage,
    setModalOpen,
    setModalType,
    setParseDataOfCsvFile,
    setReload,
    setSelectedCsvFile,
    setSelectedCsvFileName,
    setSelectedCsvItem,
    setSelectedCsvItemIndex
} from 'store/ResponseTemplate/actions';
import { Button, Typography, Box, Modal, IconButton, Stack } from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { SET_LOADING, SET_TOAST_OBJECT } from 'store/actions';
import { ADD_MULTIPLE_QUESTIONS_IN_QUESTION_REGISTRY } from 'schemas/mutation';
import { useMutation } from '@apollo/client';
import TrashIcon from 'Components/Icons/TrashIcon';
function CSVDataListTemplate() {
    const dispatch = useDispatch();
    const [addMultipleQuestionInQuestionRegistry] = useMutation(ADD_MULTIPLE_QUESTIONS_IN_QUESTION_REGISTRY);
    const { modalType, modalOpen, parsedCsvData, reload, currentPage } = useSelector((params) => params.response);
    const { companyData } = useSelector((state) => state.customization);
    /**on cross button click */
    const handleClose = () => {
        dispatch({ type: setSelectedCsvFile, selectedCsvFile: null });
        dispatch({ type: setSelectedCsvFileName, selectCsvFileName: '' });
        dispatch({ type: setParseDataOfCsvFile, parsedCsvData: [] });
        dispatch({ type: setModalOpen, modalOpen: false });
    };

    const handleCancelImport = () => {
        dispatch({ type: setModalOpen, modalOpen: true });
        dispatch({ type: setModalType, modalType: 'cancel-import-csv' });
    };

    /**On back button click */
    const handleBack = () => {
        // dispatch({ type: setModalOpen, modalOpen: false });
        // dispatch({ type: setModalType, modalType: 'import-csv' });
        // dispatch({ type: setModalOpen, modalOpen: true });

        dispatch({ type: setModalOpen, modalOpen: true });
        dispatch({ type: setModalType, modalType: 'return-back-csv-import' });
    };

    /**validate csv data if both question and response is not empty */
    const validateCsvData = () => {
        const flag = parsedCsvData.some((csvData) => !csvData?.Question || !csvData?.Response);
        return !flag;
    };

    const formatData = () =>
        parsedCsvData.map((csvData) => ({
            question: csvData.Question,
            response: csvData.Response
        }));

    const onClickFinalise = async () => {
        if (parsedCsvData && parsedCsvData?.length) {
            const isCsvDataVerified = validateCsvData();
            if (!isCsvDataVerified) {
                dispatch({
                    type: SET_TOAST_OBJECT,
                    toastObject: {
                        status: true,
                        variant: 'error',
                        message: 'Question and Response should not be empty.'
                    }
                });
            } else {
                const formattedData = formatData();
                dispatch({ type: SET_LOADING, loading: true });
                try {
                    const response = await addMultipleQuestionInQuestionRegistry({
                        variables: {
                            addMultipleQuestionRegistryInput: {
                                companyId: companyData?._id || '',
                                questionRegistries: formattedData
                            }
                        }
                    });
                    handleClose();
                    if (currentPage !== 1) {
                        dispatch({ type: setCurrentPage, currentPage: 1 });
                    } else {
                        dispatch({ type: setReload, reload: !reload });
                    }
                } catch (e) {
                    dispatch({
                        type: SET_TOAST_OBJECT,
                        toastObject: {
                            status: true,
                            variant: 'error',
                            message: e.message || 'Something error occured in server.'
                        }
                    });
                } finally {
                    dispatch({ type: SET_LOADING, loading: false });
                }
            }
        } else {
            dispatch({
                type: SET_TOAST_OBJECT,
                toastObject: {
                    status: true,
                    variant: 'error',
                    message: 'Could not find parsed data from selected csv file'
                }
            });
        }
    };

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24
    };

    const handleEditTemplate = (dataItem, index) => {
        dispatch({ type: setModalOpen, modalOpen: false });
        dispatch({ type: setSelectedCsvItem, selectedCsvItem: dataItem });
        dispatch({ type: setSelectedCsvItemIndex, selectedCsvItemIndex: index });
        dispatch({ type: setModalOpen, modalOpen: true });
        dispatch({ type: setModalType, modalType: 'edit_csv' });
    };

    const handleDelete = (e, dataItem, index) => {
        e.stopPropagation();
        dispatch({ type: setSelectedCsvItem, selectedCsvItem: dataItem });
        dispatch({ type: setSelectedCsvItemIndex, selectedCsvItemIndex: index });
        dispatch({ type: setModalOpen, modalOpen: true });
        dispatch({ type: setModalType, modalType: 'delete-csv' });
    };

    console.log('parsed csv', parsedCsvData.length);

    return (
        modalType === 'list_csv_data' && (
            <Modal open={modalOpen} onClose={handleClose} aria-labelledby="modal-modal-title " aria-describedby="modal-modal-description">
                <Box sx={style} className="modal-box csv-modal-review modalXLarge">
                    <Stack className={parsedCsvData.length > 3 ? 'has-shadow' : ''}>
                        <Stack direction="row" justifyContent="space-between" mb={2}>
                            <Typography
                                variant="h6"
                                component="h2"
                                color="#00214D"
                                fontSize="1.25rem"
                                fontWeight="400"
                                fontFamily="Poppins"
                            >
                                Review questions
                            </Typography>
                            <IconButton
                                disableRipple
                                onClick={() => {
                                    handleCancelImport();
                                }}
                                className="modal-close"
                            >
                                <CloseOutlinedIcon className="icon-yellow-fill" />
                            </IconButton>
                        </Stack>

                        <Typography component="p" fontSize="0.875rem" color="#676767" mb={2}>
                            Please review the questions and respective responses to ensure they are correct.
                        </Typography>

                        {parsedCsvData && (
                            <PerfectScrollbar
                                style={{ maxHeight: 'calc(100vh - 320px)', padding: '0 6px 0 0' }}
                                options={{ suppressScrollX: true, useBothWheelAxes: false }}
                            >
                                <Stack direction="row" flexWrap="wrap" gap={2}>
                                    {parsedCsvData?.map((item, index) => {
                                        return (
                                            <>
                                                <Stack
                                                    className="csv-review-question-card"
                                                    key={'parsed-csvData' + index}
                                                    onClick={() => handleEditTemplate(item, index)}
                                                >
                                                    <IconButton
                                                        disableRipple
                                                        className="delete"
                                                        onClick={(e) => handleDelete(e, item, index)}
                                                    >
                                                        <TrashIcon />
                                                    </IconButton>
                                                    <Typography
                                                        variant="subtitle1"
                                                        component="h3"
                                                        color="#00214D"
                                                        fontSize="1rem"
                                                        lineHeight="1.2"
                                                        fontWeight="600"
                                                    >
                                                        {item?.Question}
                                                    </Typography>
                                                    {item?.Response && (
                                                        <Typography
                                                            variant="caption"
                                                            component="p"
                                                            color="#676767"
                                                            fontSize="0.875rem"
                                                            lineHeight="1.3809"
                                                        >
                                                            {item?.Response}
                                                        </Typography>
                                                    )}
                                                </Stack>
                                            </>
                                        );
                                    })}
                                </Stack>
                            </PerfectScrollbar>
                        )}

                        <Stack
                            direction="row"
                            justifyContent="flex-end"
                            gap={2}
                            sx={{
                                position: 'relative',
                                paddingTop: '36px',

                                '.has-shadow &': {
                                    boxShadow: ' 0px -6px 11.3px -8px rgba(0, 5, 124, 0.13)'
                                }
                            }}
                        >
                            <Button variant="outlined" className="alternate-reversed" onClick={handleBack}>
                                Cancel
                            </Button>

                            <Button variant="contained" className="alternate" onClick={onClickFinalise}>
                                Finalise
                            </Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        )
    );
}

export default CSVDataListTemplate;
